import { toBig } from "@tradingApp/components/Trading/helpers/big";
import type { BigSource } from "big.js";

/**
 * Rounds a number to a specified number of decimal places.
 *
 * @example
 * // returns "1.23"
 * roundWithDecimals(1.2345, 2);
 *
 * @param {string | number} value - The value to be rounded.
 * @param {number} decimals - The number of decimal places to round to.
 * @returns {string} - Rounded value as a string.
 */
export function roundWithDecimals(value: BigSource, decimals: number): string {
  const valueNum = toBig(value);
  const multiplier = toBig(10).pow(decimals);
  const resultNum = valueNum.times(multiplier).round().div(multiplier);

  return resultNum.toString();
}
